import { render, staticRenderFns } from "./LocationHistory.vue?vue&type=template&id=36bb4d8a&scoped=true&"
import script from "./LocationHistory.vue?vue&type=script&lang=js&"
export * from "./LocationHistory.vue?vue&type=script&lang=js&"
import style0 from "./LocationHistory.vue?vue&type=style&index=0&id=36bb4d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb4d8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
